import {
  Dialog as MUIDialog,
  DialogActions as MUIDialogActions,
  DialogContent as MUIDialogContent,
  DialogContentText as MUIDialogContentText,
  DialogTitle as MUIDialogTitle,
  type DialogActionsProps,
  type DialogContentProps,
  type DialogContentTextProps,
  type DialogProps,
  type DialogTitleProps,
} from '@mui/material';

import { EventType } from '@/lib/types';

export {
  type DialogActionsProps,
  type DialogContentProps,
  type DialogContentTextProps,
  type DialogProps,
  type DialogTitleProps,
};

export interface TrackedDialogProps extends DialogProps {
  trackOpen?: (event: any) => void;
  trackClose?: (event: any) => void;
  trackEventName?: string;
  eventType?: EventType;
}

export function Dialog({
  trackOpen,
  trackClose,
  trackEventName,
  eventType = EventType.DIALOG_INTERACTION,
  open,
  onClose,
  ...props
}: TrackedDialogProps) {
  if (open && trackOpen && trackEventName) {
    trackOpen({
      name: trackEventName,
      properties: {
        eventType,
        action: 'Opened',
      },
    });
  }

  const handleClose: DialogProps['onClose'] = (event, reason) => {
    if (trackClose && trackEventName) {
      trackClose({
        name: trackEventName,
        properties: {
          eventType,
          action: 'Closed',
          closeReason: reason,
        },
      });
    }
    if (onClose) {
      onClose(event, reason);
    }
  };

  return <MUIDialog open={open} onClose={handleClose} {...props} />;
}

export function DialogTitle(props: DialogTitleProps) {
  return <MUIDialogTitle {...props} />;
}

export function DialogContent(props: DialogContentProps) {
  return <MUIDialogContent {...props} />;
}

export function DialogContentText(props: DialogContentTextProps) {
  return <MUIDialogContentText {...props} />;
}

export function DialogActions(props: DialogActionsProps) {
  return <MUIDialogActions {...props} />;
}
